import React from 'react';
import { ReferenceField, ReferenceManyField, TextField } from 'react-admin';
import makeStyles from '@mui/styles/makeStyles';
import FirstListRecord from './FirstListRecord';

const useStyles = makeStyles({
	userNameComponent: { marginInlineEnd: '0.5rem' },
});

const UserProfileField = (props) => {
	const { label, source } = props;
	const classes = useStyles();
	return (
		<ReferenceField
			link={false}
			label={label}
			source={source}
			reference="User"
			emptyText="незарегистрированый"
		>
			<ReferenceManyField reference="UserProfile" target="user">
				<FirstListRecord>
					<TextField className={classes.userNameComponent} source="lastName" />
					<TextField
						className={classes.userNameComponent}
						source="firstName"
						emptyText="Имя не указано"
					/>
					<TextField className={classes.userNameComponent} source="secondName" />
					<TextField className={classes.userNameComponent} source="phone" />
					<TextField className={classes.userNameComponent} source="email" />
				</FirstListRecord>
			</ReferenceManyField>
		</ReferenceField>
	);
};

export default UserProfileField;
